module.exports = __webpack_public_path__ + "img/list1.aeac1e3e.png";